import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

@Entity()
export class MatchingWeekCategory extends MongoEntity {
  static override _class = 'MatchingWeekCategory';
  static override _collectionName = 'matchingWeekCategories';

  @validate(options => nonOptional()({ ...options, value: options.value?.trim() }))
  @Field(() => String)
  name: Maybe<string>;

  @validate(nonOptional())
  @Field(() => Date)
  fixedEventDate: Maybe<Date>;

  static override async beforeCreate(entity: MatchingWeekCategory): Promise<void> {
    await entity.validator.validateKeys(entity, ['name', 'fixedEventDate']);
    return super.beforeCreate(entity);
  }

  static override async transformBeforeUpdate(
    oldEntity: PartialEntityData<MatchingWeekCategory>,
    update: MatchingWeekCategory,
  ): Promise<void> {
    const data = update.toJSON();
    const fields = ['name', 'fixedEventDate'].filter(field => field in data);
    await update.validator.validateKeys(update, fields);
    return super.transformBeforeUpdate(oldEntity, update);
  }
}
